import React from "react";
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "../../tickets/tickets";

const TableSkeleton = () => {
  return (
    <TableContainer
      component={Paper}
      sx={{ overflowX: "auto", overflowY: "auto", maxHeight: "55vh" }}
    >
      <Table stickyHeader size="medium" sx={{ minWidth: 1300 }}>
        <TableHead>
          <TableRow sx={{ height: 40 }}>
            {Array.from({ length: 15 }).map((header) => (
              <StyledTableCell key={header}>
                <Skeleton
                  variant="text"
                  width="70%"
                  sx={{ mx: "auto", bgcolor: "rgba(255,255,255,0.25)" }}
                />
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: 10 }).map((_, rowIndex) => (
            <TableRow key={rowIndex} sx={{ height: 40 }}>
              {Array.from({ length: 15 }).map((__, colIndex) => (
                <StyledTableCell key={`${rowIndex}-${colIndex}`}>
                  <Skeleton
                    variant="text"
                    width={colIndex === 0 ? "70%" : "90%"}
                    sx={{ mx: "auto", height: 18 }}
                  />
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableSkeleton;
